export default {
  "app.components.SideMenu.LeftMenu.clients": "clients",
  "app.components.SideMenu.LeftMenu.tag": "tag",
  "app.components.SideMenu.LeftMenu.SearchRec ": "Search Recommend",

  "app.components.SideMenu.LeftMenu.FundRec": "Fund Recommend",
    "app.components.SideMenu.LeftMenu.FundRec_FundMan": "By Fund Manager",
    "app.components.SideMenu.LeftMenu.FundRec_Condi": "By Condition",
    "app.components.SideMenu.LeftMenu.FundRec_Risk": "SIMPLE ADVISORY",

  "app.components.SideMenu.LeftMenu.transaction": "transaction",
    "app.components.SideMenu.LeftMenu.transactionDetails": "Transaction details",
    "app.components.SideMenu.LeftMenu.requestATSDetails": "Transaction details",
    
  "app.components.SideMenu.LeftMenu.ConFd": "content feed",
    "app.components.SideMenu.LeftMenu.ConFd_NewsOld": "ข่าวสาร",
    "app.components.SideMenu.LeftMenu.ConFd_Invest": "มุมมองการลงทุน",
    "app.components.SideMenu.LeftMenu.ConFd_News": "ข่าวสารและรางวัล",
    "app.components.SideMenu.LeftMenu.ConFd_ConInvest": "สาระการลงทุน",
    "app.components.SideMenu.LeftMenu.ConFd_ManualInvest": "คู่มือนักลงทุน",
    "app.components.SideMenu.LeftMenu.ConFd_NotiInvest": "ประกาศกองทุนรวม",
    "app.components.SideMenu.LeftMenu.ConFd_PVDNewsReport": "รายงาน ข่าวสารกองทุนสำรองเลี้ยงชีพ",
    "app.components.SideMenu.LeftMenu.ConFd_PVDPlaning": "คลังความรู้ด้านการวางแผนการเงิน",
    "app.components.SideMenu.LeftMenu.ConFd_PVDFactSheet": "หนังสือชี้ชวนส่วนสรุปกองทุนสำรองเลี้ยงชีพ",

  "app.components.SideMenu.LeftMenu.ContFS": "Content Feed Sort",

  "app.components.SideMenu.LeftMenu.Notification": "Notification",
    "app.components.SideMenu.LeftMenu.Notification_List": "Notification List",
    "app.components.SideMenu.LeftMenu.Notification_Detail": "Create new",
  "app.components.SideMenu.LeftMenu.PushNoti": "Push Notification",
    "app.components.SideMenu.LeftMenu.PushNoti_Compose": "Compose notification",
    "app.components.SideMenu.LeftMenu.Survey_Insight": "CSAT / NPS",

  "app.components.SideMenu.LeftMenu.Nav": "NAV",

  "app.containers.NavList.tabNavHistory": "NAV History",
  "app.containers.NavList.tabTopHolding": "Top Holding",
  "app.containers.NavList.tabSyncStatus": "Sync Status",
  "app.containers.NavList.tabLatestByFund": "Latest by fund",
  "app.containers.NavList.colLatestPriceChg": "PRICE CHG",
  "app.containers.NavList.colLatestPercentChg": "PERCENT CHG",
  "app.containers.NavList.colLatestReturnType": "RETURN TYPE",
  "app.containers.NavList.colLatestSourceTypeNav": "SOURCE TYPE NAV",
  "app.containers.NavList.latestByFundCaption": "One row per fund: the newest NAV this dashboard holds for it. {funds} funds",

  "app.containers.NavList.filterFund": "Fund",
  "app.containers.NavList.filterFundPlaceholder": "All funds",
  "app.containers.NavList.filterFundLoading": "Loading funds...",
  "app.containers.NavList.filterFundCode": "Fund code",
  "app.containers.NavList.filterFundCodePlaceholder": "Search by fund code",
  "app.containers.NavList.filterNavDate": "NAV date",
  "app.containers.NavList.filterValueDate": "Value date",
  "app.containers.NavList.filterSourceTypeNav": "Source type NAV",
  "app.containers.NavList.filterSyncBy": "Synced by",
  "app.containers.NavList.filterRowsPerPage": "Rows per page",
  "app.containers.NavList.filterAnyPlaceholder": "Any",
  "app.containers.NavList.buttonSearch": "Search",
  "app.containers.NavList.buttonClear": "Clear filters",
  "app.containers.NavList.buttonRetry": "Try again",

  "app.containers.NavList.loadingNavHistory": "Retrieving NAV history...",
  "app.containers.NavList.loadingTopHolding": "Retrieving top holdings...",
  "app.containers.NavList.loadingSyncStatus": "Retrieving sync status...",
  "app.containers.NavList.emptyHeader": "No result found",
  "app.containers.NavList.emptyBody": "No synced row matches these filters. Try widening the date range or clearing the fund filter.",
  "app.containers.NavList.errorHeader": "Could not load the synced data",
  "app.containers.NavList.errorBodyWithDetail": "The request failed ({detail}). Nothing below is up to date.",
  "app.containers.NavList.errorBodyNetwork": "The request did not reach the server. Nothing below is up to date.",
  "app.containers.NavList.errorStatus": "HTTP {status}",

  "app.containers.NavList.totalRows": "{total} rows",
  "app.containers.NavList.pageOfTotal": "Page {page} of {pages}",
  "app.containers.NavList.goToPage": "Go to page",
  "app.containers.NavList.goToPageButton": "Go",

  "app.containers.NavList.colFundNo": "FUND NO.",
  "app.containers.NavList.colFundCode": "FUND CODE",
  "app.containers.NavList.colFundName": "FUND NAME",
  "app.containers.NavList.colSyncBy": "SYNC BY",
  "app.containers.NavList.colCreatedAt": "CREATED AT",
  "app.containers.NavList.colUpdatedAt": "UPDATED AT",
  "app.containers.NavList.colNavDate": "NAV DATE",
  "app.containers.NavList.colNavPerUnit": "NAV PER UNIT",
  "app.containers.NavList.colPriceChg": "PRICE CHG",
  "app.containers.NavList.colPercentChg": "PERCENT CHG",
  "app.containers.NavList.colReturnType": "RETURN TYPE",
  "app.containers.NavList.colNavEffdateRaw": "NAV EFFDATE RAW",
  "app.containers.NavList.colSourceTypeNav": "SOURCE TYPE NAV",
  "app.containers.NavList.colSeq": "SEQ",
  "app.containers.NavList.colListTh": "LIST (TH)",
  "app.containers.NavList.colListEng": "LIST (EN)",
  "app.containers.NavList.colAmountInv": "AMOUNT INV",
  "app.containers.NavList.colPercentInv": "PERCENT INV",
  "app.containers.NavList.colPercentInvRaw": "PERCENT INV RAW",
  "app.containers.NavList.colValueDate": "VALUE DATE",
  "app.containers.NavList.colJobName": "JOB NAME",
  "app.containers.NavList.colLastRunAt": "LAST RUN AT",
  "app.containers.NavList.colLastSuccessAt": "LAST SUCCESS AT",
  "app.containers.NavList.colLastStatus": "LAST STATUS",
  "app.containers.NavList.colRowsAffected": "ROWS AFFECTED",
  "app.containers.NavList.colDetail": "DETAIL",
  "app.containers.NavList.colRowCount": "ROW COUNT",
  "app.containers.NavList.colEarliestNavDate": "EARLIEST NAV DATE",
  "app.containers.NavList.colLatestNavDate": "LATEST NAV DATE",
  "app.containers.NavList.colLatestNavPerUnit": "LATEST NAV PER UNIT",
  "app.containers.NavList.colLastSyncBy": "LAST SYNC BY",

  "app.containers.NavList.sectionSyncJobs": "Sync jobs",
  "app.containers.NavList.sectionCoverage": "Coverage per fund",
  "app.containers.NavList.sectionMissingFunds": "Funds with no NAV history",
  "app.containers.NavList.missingFundsBody": "{count} of {total} funds in the fund master have no row in funds_nav_history at all.",
  "app.containers.NavList.missingFundsNone": "Every fund in the fund master has NAV history. {total} funds covered.",
  "app.containers.NavList.missingFundsUnknown": "The fund master could not be read, so coverage gaps cannot be listed.",
  "app.containers.NavList.coverageSummaryCount": "{funds} funds, {rows} NAV rows in total",
  "app.containers.NavList.badgeNoData": "NO DATA",
  "app.containers.NavList.refresh": "Refresh",

  "app.container.ClientDetail.Conservative": "อนุรักษ์นิยม (ระดับ 1)",
  "app.container.ClientDetail.ModerateConservative": "ยับยั้งปานกลาง (ระดับ 2)",
  "app.container.ClientDetail.Moderate": "ปานกลาง (ระดับ 3)",
  "app.container.ClientDetail.ModerateAggressive": "ปานกลางก้าวร้าว (ระดับ 4)",
  "app.container.ClientDetail.Aggressive5": "ก้าวร้าว (ระดับ 5)",
  "app.container.ClientDetail.Aggressive6": "ก้าวร้าว (ระดับ 6)"
};
